import React, { Component } from 'react'
import {
    Alert,
    FormControlLabel,
    Checkbox,
    FormControl,
    Select,
    MenuItem,
    Box,
} from '@mui/material'
import LoadingDefault from '../../Elements/Loading/LoadingDefault'
import SelectList from '../../Elements/SelectList'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class DisplayItemCustomActionButtonSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            action:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.action
                    ? this.props.item.settings.action
                    : null,
            kedocx:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.kedocx
                    ? this.props.item.settings.kedocx
                    : null,
            iframe:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.iframe
                    ? this.props.item.settings.iframe
                    : null,
            report:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.report
                    ? this.props.item.settings.report
                    : null,
            report_format: this.props.item?.settings?.report_format,
            kedocx_format:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.kedocx_format
                    ? this.props.item.settings.kedocx_format
                    : null,
            event_id:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.event_id
                    ? this.props.item.settings.event_id
                    : null,
            webhook_id:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.webhook_id
                    ? this.props.item.settings.webhook_id
                    : null,
            popup_view:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.popup_view
                    ? this.props.item.settings.popup_view
                    : null,
            popup_custom_view:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.popup_custom_view
                    ? this.props.item.settings.popup_custom_view
                    : null,
            kedocxs: [],
            reports: [],
            kedocxs_loaded: false,
            reports_loaded: false,
        }
        this.onChange = this.onChange.bind(this)
        this.fetchKedocxs = this.fetchKedocxs.bind(this)
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value })

        this.props.onChange(event.target.name, event.target.value)
    }

    fetchKedocxs() {
        const api = this.props.kedo.api()
        let filter = {
            params: {
                defDossier: this.props.item.def_dossier_id,
            },
        }

        api.get(api.getKedocxEndpoint(), filter).then((response) =>
            this.setState({
                kedocxs: response.data.results,
                kedocxs_loaded: true,
            })
        )
    }

    renderKedocxSettings() {
        if (this.state.kedocxs_loaded === false) {
            this.fetchKedocxs()
        }

        return (
            <>
                <FormInputLabel>
                    <strong>
                        {this.props.kedo.t('Kedocx')}{' '}
                        {this.props.kedo.t('Template').toLowerCase()}
                    </strong>
                </FormInputLabel>
                {this.state.kedocxs_loaded && this.state.kedocxs.length <= 0 ? (
                    <Alert severity={'warning'}>
                        {this.props.kedo.t('No files found')}
                    </Alert>
                ) : this.state.kedocxs_loaded === true ? (
                    <>
                        <Select
                            size="small"
                            value={this.state.kedocx}
                            onChange={this.onChange}
                            name={'kedocx'}
                            displayEmpty
                            disabled={this.props.disabled}
                        >
                            <MenuItem value={''}>
                                {this.props.kedo.t('Choose an option')}
                            </MenuItem>
                            {this.state.kedocxs.map((item) => (
                                <MenuItem key={item.uuid} value={item.uuid}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormControl fullWidth margin="dense">
                            <FormInputLabel>
                                {this.props.kedo.t('Format')}
                            </FormInputLabel>
                            <Select
                                size="small"
                                value={this.state.kedocx_format}
                                onChange={this.onChange}
                                name={'kedocx_format'}
                                displayEmpty
                                disabled={this.props.disabled}
                            >
                                <MenuItem value={''}>
                                    {this.props.kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value={'pdf'}>PDF</MenuItem>
                                <MenuItem value={'docx'}>Word (.docx)</MenuItem>
                                <MenuItem value={'html'}>HTML</MenuItem>
                            </Select>
                        </FormControl>
                    </>
                ) : (
                    <LoadingDefault as={'span'} />
                )}
            </>
        )
    }
    renderFireWebhookView() {
        return (
            <Box sx={{ width: '100%' }}>
                <strong>
                    {this.props.kedo.t(
                        'Select webhook to be triggered upon click'
                    )}
                </strong>
                <SelectList
                    currentValue={this.state.webhook_id}
                    disableInit={true}
                    disabled={this.props.disabled}
                    onClear={() =>
                        this.setState({ webhook_id: null }, () =>
                            this.props.onChange('webhook_id', null)
                        )
                    }
                    searchName={'search'}
                    kedo={this.props.kedo}
                    urlParams={{ defDossier: this.props.item.def_dossier_id }}
                    onDisplayName={(item) => {
                        return item.id + ': ' + item.name
                    }}
                    url={this.props.kedo.api().getWebhookEndpoint()}
                    onSelect={(item) => {
                        this.setState({ webhook_id: item.id }, () =>
                            this.props.onChange('webhook_id', item.id)
                        )
                    }}
                />
                <FormControl margin="normal">
                    <FormControlLabel
                        control={
                            <Checkbox
                                size="small"
                                checked={this.state.iframe}
                                name="iframe"
                                onChange={(event) => {
                                    const { name, checked } = event.target

                                    this.setState({
                                        [name]: checked,
                                    })

                                    this.props.onChange(name, checked)
                                }}
                                disabled={this.props.disabled}
                            />
                        }
                        label={this.props.kedo.t('iframe')}
                        sx={{
                            mb: 0,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                                color: 'text.primary',
                            },
                        }}
                    />
                </FormControl>
            </Box>
        )
    }

    renderFireEventView() {
        return (
            <Box sx={{ width: '100%' }}>
                <strong>
                    {this.props.kedo.t(
                        'Select event to be triggered upon click'
                    )}
                </strong>
                <SelectList
                    currentValue={this.state.event_id}
                    disableInit={true}
                    disabled={this.props.disabled}
                    onClear={() =>
                        this.setState({ event_id: null }, () =>
                            this.props.onChange('event_id', null)
                        )
                    }
                    searchName={'search'}
                    kedo={this.props.kedo}
                    urlParams={{ defDossier: this.props.item.def_dossier_id }}
                    onDisplayName={(item) => {
                        return item.id + ': ' + item.name
                    }}
                    url={this.props.kedo.api().getEventEndpoint()}
                    onSelect={(item) => {
                        this.setState({ event_id: item.id }, () =>
                            this.props.onChange('event_id', item.id)
                        )
                    }}
                />
            </Box>
        )
    }

    renderPopupTabOrView() {
        return (
            <Box sx={{ width: '100%' }}>
                <strong>
                    {this.props.kedo.t('Select modal position to be shown')}
                </strong>
                <SelectList
                    currentValue={this.state.popup_view}
                    disableInit={true}
                    disabled={this.props.disabled}
                    onClear={() =>
                        this.setState({ popup_view: null }, () =>
                            this.props.onChange('popup_view', null)
                        )
                    }
                    searchName={'search'}
                    kedo={this.props.kedo}
                    urlParams={{ defDossier: this.props.item.def_dossier_id }}
                    onDisplayName={(item) => {
                        return (
                            item.id +
                            ': ' +
                            this.props.kedo
                                .env()
                                .translateItem(item, 'displayposition')
                        )
                    }}
                    url={this.props.kedo.api().getDisplayPositionEndpoint()}
                    onSelect={(item) => {
                        this.setState({ popup_view: item.id }, () =>
                            this.props.onChange('popup_view', item.id)
                        )
                    }}
                />
                <strong>
                    {this.props.kedo.t('Select custom position to be shown')}
                </strong>
                <SelectList
                    currentValue={this.state.popup_custom_view}
                    onClear={() =>
                        this.setState({ popup_view: null }, () =>
                            this.props.onChange('popup_custom_view', null)
                        )
                    }
                    disableInit={true}
                    disabled={this.props.disabled}
                    searchName={'search'}
                    kedo={this.props.kedo}
                    urlParams={{ defDossier: this.props.item.def_dossier_id }}
                    onDisplayName={(item) => {
                        return (
                            item.id +
                            ': ' +
                            this.props.kedo
                                .env()
                                .translateItem(item, 'displayposition')
                        )
                    }}
                    url={this.props.kedo.api().getDisplayCustomViewEndpoint()}
                    onSelect={(item) => {
                        this.setState({ popup_custom_view: item.id }, () =>
                            this.props.onChange('popup_custom_view', item.id)
                        )
                    }}
                />
            </Box>
        )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <div>
                <FormControl fullWidth margin="dense">
                    <FormInputLabel>{kedo.t('Action')}</FormInputLabel>
                    <Select
                        size="small"
                        value={this.state.action}
                        name={'action'}
                        onChange={this.onChange}
                        displayEmpty
                        disabled={this.props.disabled}
                    >
                        <MenuItem value={''}>
                            {kedo.t('Choose an option')}
                        </MenuItem>
                        <MenuItem value={'kedocx'}>{kedo.t('Kedocx')}</MenuItem>
                        <MenuItem value={'popup_tab_or_view'}>
                            {kedo.t('popup_tab_or_view')}
                        </MenuItem>
                        <MenuItem value={'fire_event'}>
                            {kedo.t('fire_event')}
                        </MenuItem>
                        <MenuItem value={'fire_webhook'}>
                            {kedo.t('fire_webhook')}
                        </MenuItem>
                        <MenuItem
                            disabled={!kedo.env().hasModule('reports')}
                            value={'report'}
                        >
                            {kedo.t('report')}
                        </MenuItem>
                    </Select>
                </FormControl>
                {this.state.action === 'kedocx' ? <hr /> : null}
                {this.state.action === 'kedocx'
                    ? this.renderKedocxSettings()
                    : null}
                {this.state.action === 'report'
                    ? this.renderReportSettings()
                    : null}
                {this.state.action === 'popup_tab_or_view'
                    ? this.renderPopupTabOrView()
                    : null}
                {this.state.action === 'fire_event'
                    ? this.renderFireEventView()
                    : null}
                {this.state.action === 'fire_webhook'
                    ? this.renderFireWebhookView()
                    : null}
            </div>
        )
    }

    fetchReports() {
        const api = this.props.kedo.api()
        this.setState({ loading: true, reports_loaded: true })
        let data = {
            params: {
                environment_id: this.props.kedo.env().getEnvironmentId(),
            },
        }

        api.get('/module/report', data)
            .then((response) => {
                this.setState({
                    loading: false,
                    reports: response.data.results,
                })
            })
            .catch(() => {
                this.setState({ loading: false })
            })
    }

    renderReportSettings() {
        const kedo = this.props.kedo
        if (this.state.reports_loaded === false) {
            this.fetchReports()
        }

        return (
            <>
                <FormInputLabel>
                    <strong>{this.props.kedo.t('Report')}</strong>
                </FormInputLabel>
                {this.state.reports_loaded && this.state.reports.length <= 0 ? (
                    <Alert severity={'warning'}>
                        {kedo.t('No reports found')}
                    </Alert>
                ) : this.state.reports_loaded === true ? (
                    <>
                        <FormControl fullWidth margin="dense">
                            <Select
                                size="small"
                                value={this.state.report}
                                onChange={this.onChange}
                                name={'report'}
                                displayEmpty
                                disabled={this.props.disabled}
                            >
                                <MenuItem value={''}>
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                {this.state.reports.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth margin="dense">
                            <FormInputLabel>{kedo.t('Format')}</FormInputLabel>
                            <Select
                                size="small"
                                value={this.state.report_format}
                                onChange={this.onChange}
                                name={'report_format'}
                                displayEmpty
                                disabled={this.props.disabled}
                            >
                                <MenuItem value={''}>
                                    {kedo.t('Choose an option')}
                                </MenuItem>
                                <MenuItem value={'pdf'}>PDF</MenuItem>
                                <MenuItem value={'docx'}>Word (.docx)</MenuItem>
                                <MenuItem value={'html'}>HTML</MenuItem>
                                <MenuItem value={'xlsx'}>Excel</MenuItem>
                            </Select>
                        </FormControl>
                    </>
                ) : (
                    <LoadingDefault as={'span'} />
                )}
            </>
        )
    }
}

export default DisplayItemCustomActionButtonSettings
